import React from "react";
import styles from './Styles.module.scss';
import classNames from 'classnames';

export default function MessageInput({
  form,
  className,
  placeholder,
  value,
  required,
  pattern,
  disabled,
  name,
  defaultValue,
  register,
  onChange,
  onBlur,
}) {
  return (
    <textarea
      form={form}
      value={value}
      disabled={disabled}
      name={name}
      ref={register}
      required={required}
      pattern={pattern}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      className={classNames(styles.container, className)}
    />
  )
}
